import { Radio } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledStartUccRadioButton = styled(Radio)(({ theme }) => ({
  '& .MuiSvgIcon-root': {
    fontSize: theme.typography.pxToRem(14),
  },
  marginLeft: 1,
}));
